var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: {
        action: "",
        method: "post",
        name: "ListSelect",
        id: "ListSelect"
      }
    },
    [
      _c("div", { staticClass: "os_noticeRes" }, [
        _vm.isLoading
          ? _c("div", { staticClass: "loading-overlay" }, [
              _c("div", { staticClass: "spinner" })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "osResHeader padLS padRS" }, [
          _c("h1", { staticClass: "txtC" }, [
            _c("img", { attrs: { src: _vm.topImgPath } })
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "padTS padBL padLS padRS" },
          [
            _vm._m(0),
            _vm._v(" "),
            _vm._l(_vm.form.questions, function(question, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "padTL",
                  staticStyle: { "max-width": "710px", margin: "auto" }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "marBS fntH6 bolder quill-viewer",
                      staticStyle: { color: "#222" }
                    },
                    [
                      _c("span", { staticStyle: { color: "#1874cd" } }, [
                        _vm._v("[ 약관 " + _vm._s(index + 1) + " ]")
                      ])
                    ]
                  ),
                  _c("div", {
                    staticClass: "quill-viewer",
                    domProps: { innerHTML: _vm._s(question.text) }
                  }),
                  _vm._v(" "),
                  _c("p"),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "quill-viewer",
                    staticStyle: {
                      overflow: "scroll",
                      width: "100%",
                      height: "200px",
                      padding: "10px",
                      "background-color": "#f9f9f9",
                      border: "1px solid #E0E0E0"
                    },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.form.answers[index]
                          ? _vm.form.answers[index].content
                          : ""
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "marTM txtR moTxtL",
                      staticStyle: {
                        "text-indent": "1.1em",
                        "max-width": "800px"
                      }
                    },
                    [
                      _c("label", { staticClass: "disIb fntP agree-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.answers[index].agree,
                              expression: "form.answers[index].agree"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "agree_" + index,
                            value: "Y"
                          },
                          domProps: {
                            checked: _vm._q(_vm.form.answers[index].agree, "Y")
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.form.answers[index],
                                "agree",
                                "Y"
                              )
                            }
                          }
                        }),
                        _vm._v("\n            동의\n          ")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "disIb fntP agree-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.answers[index].agree,
                              expression: "form.answers[index].agree"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "agree_" + index,
                            value: "N"
                          },
                          domProps: {
                            checked: _vm._q(_vm.form.answers[index].agree, "N")
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.form.answers[index],
                                "agree",
                                "N"
                              )
                            }
                          }
                        }),
                        _vm._v("\n            동의안함\n          ")
                      ])
                    ]
                  )
                ]
              )
            }),
            _vm._v(" "),
            _c("p", { staticClass: "marTL txtC" }, [
              _c("input", {
                staticClass: "fntP bolder",
                staticStyle: {
                  "background-color": "#1874cd",
                  width: "8em",
                  height: "2.5em",
                  color: "#fff",
                  border: "0px"
                },
                attrs: {
                  disabled: _vm.isPreviewMode,
                  type: "button",
                  id: "submit_button",
                  value: "항공일정 확인"
                },
                on: { click: _vm.handleSubmit }
              })
            ])
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "clearfix",
        staticStyle: {
          "background-color": "#f5f5f5",
          "max-width": "710px",
          margin: "0px auto",
          padding: "1.5em 0px"
        }
      },
      [
        _c("p", { staticClass: "floL txtC", staticStyle: { width: "25%" } }, [
          _c("img", {
            attrs: { src: require("./img/personalIcon.png"), alt: "" }
          })
        ]),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "floL fntP pcView",
            staticStyle: {
              width: "75%",
              "padding-left": "4%",
              "text-align": "left",
              "line-height": "120px",
              "border-left": "1px solid #e5e5e5"
            }
          },
          [
            _vm._v(
              "개인정보 관련 동의 완료 후 본인의 항공 일정을 확인하실 수 있습니다."
            )
          ]
        )
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50c7045a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50c7045a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nca/terms.vue
// module id = null
// module chunks = 